import { Stack, Typography } from "@mui/material";
import { CustomChip, ReuseInput, ReuseTooltip } from "../../../../ui";
import { AlertInCircleIcon } from "../../../../images";
import { SubCIDBtn } from "../../../../ui/buttons";

export const CIDUploadMethod = ({
  isLeadTools,
  setCID,
  cid,
  currentSubCID,
  isLoading,
  setSubCID,
}: {
  isLeadTools: boolean;
  cid: string;
  currentSubCID: string[];
  setCID: (cid: string) => void;
  setSubCID: (subCID: string[]) => void;
  isLoading: boolean;
}) => {
  return (
    <Stack gap={"16px"}>
      {isLeadTools ? (
        <Stack gap={"16px"}>
          <Stack flexDirection={"row"} gap={"8px"} alignItems={"center"}>
            <Typography
              component="span"
              variant="body1"
              sx={{ color: "#464646", lineHeight: "24px" }}
            >
              Check for updates to refresh the data for this CID.
            </Typography>
            <ReuseTooltip
              maxWidth={"184px"}
              text={
                "This action will update the data by re-analyzing the accounts that were already processed"
              }
            >
              <AlertInCircleIcon />
            </ReuseTooltip>
          </Stack>
          <Typography
            sx={{
              color: "#232323",
              lineHeight: "28px",
              fontWeight: 500,
              fontSize: "22px",
            }}
          >
            {cid}
          </Typography>
        </Stack>
      ) : (
        <Stack paddingTop={"16px"} paddingBottom={"24px"}>
          <ReuseInput
            isDisabled={isLoading}
            name="cid"
            handleInputChange={(field, value) => setCID(value)}
            errorMessage={""}
            value={cid}
            label="CID"
            placeholder="AA12345"
            isError={false}
            setErrorHandler={() => {}}
          />
        </Stack>
      )}
      <Stack gap={"16px"}>
        {currentSubCID.length > 0 && (
          <Stack>
            <Typography variant="button" sx={{ color: "#585858" }}>
              Sub-CID(s)
            </Typography>
            <Stack sx={{ flexDirection: "row", gap: "8px", flexWrap: "wrap" }}>
              {currentSubCID.map((el) => (
                <CustomChip key={el} label={el} />
              ))}
            </Stack>
          </Stack>
        )}
        {(currentSubCID.length > 0 || !isLeadTools) && (
          <Stack maxWidth={"292px"}>
            <SubCIDBtn
              startSubCID={[]}
              setSubCidsHandler={setSubCID}
              isDisabled={!cid || isLoading}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
